import React from 'react';

function HeroSection({ navigateTo }) {
  return (
    <section className="hero-bg text-white py-20 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight">
          KSL: Engineering the Future
        </h1>
        <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-300">
          Redefining technology through innovative IT and AI products and services.
          We deliver intelligent solutions that empower businesses to unlock their full potential.
        </p>
        <div className="mt-10 flex justify-center space-x-4">
          <button onClick={() => navigateTo('services')} className="btn btn-primary text-lg">
            Our Services
          </button>
          <button onClick={() => navigateTo('contact')} className="btn btn-secondary text-lg">
            Contact Us
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroSection; 